import React from "react";
import { useCruise } from "../context/CruiseContext";
import { Music, Waves, Sparkles, Disc3, Users, Gamepad2, PartyPopper, Star } from "lucide-react";

const ICONS = [Music, Waves, Sparkles, Disc3, Users, Gamepad2, PartyPopper, Star];

const Experience = () => {
  const { EXPERIENCES, EXPERIENCE_IMAGES, experienceKicker, EVENT } = useCruise();
  return (
    <section id="experience" className="relative py-24 bg-[#111111] overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src={EXPERIENCE_IMAGES[0]} alt="House Heads dancing at a House Heads At Sea cruise party" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A0A0A]/85" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5">
        <div className="text-center mb-14">
          <p className="font-cond uppercase tracking-[0.4em] text-[#E50914] text-sm mb-3">{experienceKicker}</p>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl">
            The <span className="text-[#E50914]">Experience</span>
          </h2>
          <div className="flex justify-center mt-4">
            <span className="section-line" />
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-16">
          {EXPERIENCES.map((exp, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={exp}
                className="group bg-[#1A1A1A] border border-white/5 hover:border-[#E50914] p-6 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1"
              >
                <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#E50914]/10 text-[#E50914] group-hover:bg-[#E50914] group-hover:text-white transition-colors mb-4">
                  <Icon size={26} />
                </span>
                <p className="font-cond uppercase text-white text-sm tracking-widest">{exp}</p>
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {EXPERIENCE_IMAGES.map((img, i) => (
            <div key={i} className="relative overflow-hidden rounded-2xl group h-52">
              <img
                src={img}
                alt={`House Heads At Sea ${EVENT.tagline} — ${["dancing on deck", "Unity Games", "movie night", "theme party"][i] || "party at sea"}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/80 to-transparent" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
